import { AfterViewInit, Component, ElementRef, inject, input, OnDestroy, viewChild } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { EmulateTouchPanningService } from '../../../services/emulate-touch-panning-service';
import { MobileScrollableContentWidget } from '../../widgets';
import { MobileFrameService } from '../mobile-frame.service';
import { MobileNavBarPart } from '../nav-bar/mobile-nav-bar.part';
import { MobileToolbarPart } from '../toolbar/mobile-toolbar.part';
import { MobileLayoutService } from './mobile-layout.service';


@Component({
	selector: 'mobile-layout-part',
	standalone: true,
	imports: [
		MobileNavBarPart,
		MobileScrollableContentWidget,
		NgbTooltipModule,
		MobileToolbarPart,
	],
	templateUrl: './mobile-layout.part.html',
	styleUrls: ['./mobile-layout.part.scss']
})


export class MobileLayoutPart implements AfterViewInit, OnDestroy {

	public layout = inject(MobileLayoutService);
	public frame = inject(MobileFrameService);
	private touchEmulator = inject(EmulateTouchPanningService);

	private readonly scrollDiv = viewChild.required<ElementRef<HTMLDivElement>>('scrollDiv');

	public readonly restrictNavigation = input.required<boolean>();

	public onPageContentScroll(event: Event) {
		const targetElement = event.target as HTMLElement;
		const scrollPosition = targetElement.scrollTop;
		const scrollHeader = document.querySelector('.header-auto-show');
		if (scrollHeader) {
			if (scrollPosition >= 15) {
				scrollHeader.classList.add('header-active');
			} else scrollHeader.classList.remove('header-active');
		}
	}

	ngAfterViewInit() {
		this.touchEmulator.add('mobile-layout-page-scroller', this.scrollDiv());
	}

	ngOnDestroy() {
		this.touchEmulator.remove('mobile-layout-page-scroller');
	}
}
